import { DUELO_VERSION } from '../../../config/version'
export { DUELO_VERSION }
console.log(`[DUELO] versão carregada: ${DUELO_VERSION}`)
